export default {
  apiKey: 'AIzaSyBuhOhaRLygDalF3NjfYLcdMItI_RffbOw',
  authDomain: 'vue-crm-app-5be2d.firebaseapp.com',
  databaseURL: 'https://vue-crm-app-5be2d.firebaseio.com',
  projectId: 'vue-crm-app-5be2d',
  storageBucket: 'vue-crm-app-5be2d.appspot.com',
  messagingSenderId: '1039387831175',
  appId: '1:1039387831175:web:0e42f2d76103a1e94b8122',
  measurementId: 'G-3DD6Z64SNN'
}
